// Utility functions for formatting data

/**
 * Format organization name from ID to display name
 * Converts "crisp_technologies_llc" to "Crisp Technologies LLC"
 */
export function formatOrganizationName(orgId) {
  if (!orgId) return 'Unknown Organization'
  
  // Convert underscores to spaces and split into words
  const words = orgId.split('_')
  
  // Capitalize each word
  const formattedWords = words.map(word => {
    // Handle common abbreviations
    if (word.toLowerCase() === 'llc') return 'LLC'
    if (word.toLowerCase() === 'inc') return 'Inc'
    if (word.toLowerCase() === 'corp') return 'Corp'
    if (word.toLowerCase() === 'ltd') return 'Ltd'
    if (word.toLowerCase() === 'co') return 'Co'
    
    // Capitalize first letter of each word
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  })
  
  return formattedWords.join(' ')
}

/**
 * Format organization ID from display name
 * Converts "Crisp Technologies LLC" to "crisp_technologies_llc"
 */
export function formatOrganizationId(displayName) {
  if (!displayName) return ''
  
  return displayName
    .toLowerCase()
    .replace(/[^a-zA-Z0-9\s]/g, '') // Remove special characters
    .replace(/\s+/g, '_') // Replace spaces with underscores
    .trim()
}

/**
 * Get organization display name from organization data
 * Uses the name field if available, otherwise formats the ID
 */
export function getOrganizationDisplayName(orgData) {
  if (!orgData) return 'Unknown Organization'
  
  // If organization has a proper name field, use it
  if (orgData.name && orgData.name !== orgData.id) {
    return orgData.name
  }
  
  // Otherwise, format the ID
  return formatOrganizationName(orgData.id || orgData.organizationId)
}
